import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import StoreFrontend from '../components/store/StoreFrontend';

export default function StoreFrontendPage() {
    const { storeId } = useParams();
    const [resolvedStoreId, setResolvedStoreId] = useState(storeId || '');
    const [loading, setLoading] = useState(!storeId);

    useEffect(() => {
        if (storeId) {
            setResolvedStoreId(storeId);
            setLoading(false);
            return;
        }

        let mounted = true;
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
        axios
            .get(`${API_BASE_URL}/public/stores/default`)
            .then((res) => {
                if (!mounted) return;
                setResolvedStoreId(String(res.data?.id || ''));
            })
            .catch(() => {
                if (!mounted) return;
                setResolvedStoreId('');
            })
            .finally(() => {
                if (mounted) setLoading(false);
            });

        return () => {
            mounted = false;
        };
    }, [storeId]);

    if (loading) {
        return <div className="panel">Loading store...</div>;
    }

    if (!resolvedStoreId) {
        return <div className="panel">No public store is currently available.</div>;
    }

    return <StoreFrontend storeId={resolvedStoreId} />;
}
